import type { Skill } from '../types';
import { useQuery } from '@tanstack/react-query';
import HttpUtils from '~/agent/http-utils';
import FetchPromise from '~/agent/fetch-promise';
import { skillsKeys } from '../utils';

type GetSkillsParams = {
  query?: string;
  limit?: number;
};

type SkillsResponse = {
  skills: Skill[];
};

const SKILLS_API_ROOT_URL = 'skills';

const getSkills = ({ query, limit }: GetSkillsParams): Promise<SkillsResponse> => {
  const params = { query, limit };
  Object.keys(params).forEach((key) => (params[key] === undefined || params[key] === null) && delete params[key]);

  return FetchPromise.get(
    HttpUtils.buildUriWithQueryString(`${SKILLS_API_ROOT_URL}`, {
      ...params,
    }),
  );
};

export const useGetSkills = (query: string = null, limit: number = null, enabled: boolean = true) =>
  useQuery<SkillsResponse, JQuery.jqXHR>(skillsKeys.skills({ query, limit }), () => getSkills({ query, limit }), {
    enabled,
  });
